import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import AssignCompetenciesServices from "./assignCompetencies.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getAssignCompetencies = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_ASSIGN_COMPETENCIES,
      payload: true,
    });
    const resp = await AssignCompetenciesServices.getAssignCompetencies(
      filters
    );
    dispatch({
      type: actions.GET_ASSIGN_COMPETENCIES,
      payload: {
        assignCompetencies: resp.data.data,
        assignCompetenciesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.ASSIGN_COMPETENCIES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.ASSIGN_COMPETENCIES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_ASSIGN_COMPETENCIES,
      payload: false,
    });
  }
};

export const getAssignCompetenciesById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_ASSIGN_COMPETENCIES_BY_ID,
      payload: true,
    });
    const resp = await AssignCompetenciesServices.getAssignCompetenciesById(id);
    dispatch({
      type: actions.GET_ASSIGN_COMPETENCIES_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.ASSIGN_COMPETENCIES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.ASSIGN_COMPETENCIES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_ASSIGN_COMPETENCIES_BY_ID,
      payload: false,
    });
  }
};

{
  /*Por default  export const saveAssignCompetencies =
  (data, setShowModal) => async (dispatch, getState) =>*/
}
export const saveAssignCompetencies = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_ASSIGN_COMPETENCIES,
      payload: true,
    });
    const resp = await AssignCompetenciesServices.saveAssignCompetencies(data);
    const { assignCompetencies, assignCompetenciesLength } =
      getState().assignCompetencies;
    const _assignCompetencies = [...assignCompetencies, resp.data];
    dispatch({
      type: actions.GET_ASSIGN_COMPETENCIES,
      payload: {
        assignCompetencies: _assignCompetencies,
        assignCompetenciesLength: assignCompetenciesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_ASSIGN_COMPETENCIES,
      payload: "",
    });
    //setShowModal(false);
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_ASSIGN_COMPETENCIES,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_ASSIGN_COMPETENCIES,
      payload: false,
    });
  }
};

export const saveAssignCompetenciesMF =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_ASSIGN_COMPETENCIES,
        payload: true,
      });
      const resp = await AssignCompetenciesServices.saveAssignCompetencies(
        data
      );
      const { assignCompetencies, assignCompetenciesLength } =
        getState().assignCompetencies;
      const _assignCompetencies = [...assignCompetencies, resp.data];
      dispatch({
        type: actions.GET_ASSIGN_COMPETENCIES,
        payload: {
          assignCompetencies: _assignCompetencies,
          assignCompetenciesLength: assignCompetenciesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_ASSIGN_COMPETENCIES,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_ASSIGN_COMPETENCIES,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_ASSIGN_COMPETENCIES,
        payload: false,
      });
    }
  };

export const editAssignCompetencies =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_ASSIGN_COMPETENCIES,
        payload: true,
      });
      const resp = await AssignCompetenciesServices.editAssignCompetencies(
        id,
        data
      );
      const { assignCompetencies, assignCompetenciesLength } =
        getState().assignCompetencies;
      const dataT = resp.data;
      assignCompetencies[index] = resp.data;
      dispatch({
        type: actions.GET_ASSIGN_COMPETENCIES,
        payload: {
          assignCompetencies: assignCompetencies,
          assignCompetenciesLength: assignCompetenciesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_ASSIGN_COMPETENCIES,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      {
        /*const _data = {
        data:[
          {
            funcion_descriptor:dataT.posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      }); */
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_ASSIGN_COMPETENCIES,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_ASSIGN_COMPETENCIES,
        payload: false,
      });
    }
  };

export const deleteAssignCompetencies =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_ASSIGN_COMPETENCIES,
        payload: true,
      });
      await AssignCompetenciesServices.deleteAssignCompetencies(id);
      const { assignCompetencies, assignCompetenciesLength } =
        getState().assignCompetencies;
      assignCompetencies.splice(index, 1);
      dispatch({
        type: actions.GET_ASSIGN_COMPETENCIES,
        payload: {
          assignCompetencies: assignCompetencies,
          assignCompetenciesLength: assignCompetenciesLength - 1,
        },
      });
      dispatch({
        type: actions.ASSIGN_COMPETENCIES_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.ASSIGN_COMPETENCIES_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_ASSIGN_COMPETENCIES,
        payload: false,
      });
    }
  };
